/*
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-11 16:05:36
 * @LastEditors: liushuaibo liushuaibo@yangxuan.net
 * @LastEditTime: 2023-07-07 17:09:17
 */
import AuthDirection from './auth';
import loadMoreDirection from './loadMore';
import scrollLazyLoad from './scrollLazyLoad';
import akTooltipAutoShow from './akTooltipAutoShow';
export default {
  'auth': AuthDirection,
  'loadMore': loadMoreDirection,
  'scrollLazyLoad': scrollLazyLoad,
  'akTooltipAutoShow': akTooltipAutoShow,
}